// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__xT3FL","lds-ring":"Spinner_lds-ring__wDzI5"};